/* Session-scoped commerce attribution. Coupon codes are never sent to analytics. */
(() => {
  'use strict';
  if (window.Shopify?.designMode || window.commerceAttribution) return;
  const key = 'commerce-attribution-v1';
  const ttl = 30 * 60 * 1000;
  const paidSources = new Set(['google', 'google_ads', 'googleads', 'adwords', 'bing', 'microsoft', 'facebook', 'fb', 'instagram', 'ig', 'meta', 'tiktok', 'pinterest', 'youtube']);
  const paidMedia = new Set(['cpc', 'ppc', 'paid', 'paid_social', 'paid-social', 'paid_search', 'paid-search', 'display', 'cpm']);
  const clean = value => String(value || '').trim().slice(0, 100);
  const params = new URLSearchParams(location.search);
  let state;
  try { state = JSON.parse(sessionStorage.getItem(key)); } catch (_) { /* Optional storage. */ }
  if (!state || !['points', 'paid', 'regular'].includes(state.channel) || !Number.isFinite(state.updated) || Date.now() - state.updated > ttl) state = { channel: 'regular', original: 'regular', updated: Date.now() };
  if (params.has('utm_source') || params.has('utm_medium')) {
    const source = clean(params.get('utm_source')).toLowerCase();
    const medium = clean(params.get('utm_medium')).toLowerCase();
    const incoming = paidSources.has(source) && (!medium || paidMedia.has(medium)) ? 'paid' : 'regular';
    // Lower-priority visits do not erase an existing paid/points journey.
    if (incoming === 'paid' || state.channel === 'regular') {
      if (state.channel !== 'points') state.channel = incoming;
      state.source = clean(params.get('utm_source'));
      state.medium = clean(params.get('utm_medium'));
      state.campaign = clean(params.get('utm_campaign'));
    }
    if (!state.entryRecorded) state.original = incoming;
  }
  state.entryRecorded = true;
  function save() {
    state.updated = Date.now();
    try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) { /* Attribution must not block shopping. */ }
  }
  function context() {
    if (Date.now() - state.updated > ttl) state = { channel: 'regular', original: 'regular', updated: Date.now(), entryRecorded: true };
    let selected = '';
    try { selected = sessionStorage.getItem('points-selected-discount') || ''; } catch (_) { /* Optional. */ }
    const activeCode = params.has('discount') ? params.get('discount') : selected;
    const pointsSelected = Boolean(state.pointsCode && activeCode === state.pointsCode);
    save();
    return { traffic_channel: state.channel, original_traffic_channel: state.original,
      points_coupon_selected: pointsSelected, attribution_utm_source: state.source || '',
      attribution_utm_medium: state.medium || '', attribution_utm_campaign: state.campaign || '' };
  }
  function tags() {
    const data = context();
    try {
      window.clarity = window.clarity || function() { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('set', 'traffic_channel', data.traffic_channel);
      window.clarity('set', 'original_traffic_channel', data.original_traffic_channel);
      window.clarity('set', 'points_coupon_selected', String(data.points_coupon_selected));
      for (const name of ['attribution_utm_source', 'attribution_utm_medium', 'attribution_utm_campaign']) {
        if (data[name]) window.clarity('set', name, data[name]);
      }
    } catch (_) { /* Analytics must not affect commerce. */ }
    return data;
  }
  function event(action) {
    try {
      const data = tags();
      // Encode the channel in the event too: Clarity tags describe a session,
      // so they cannot identify the channel at the time of an individual event.
      window.clarity('event', 'commerce_' + action + '_' + data.traffic_channel);
    } catch (_) { /* Analytics must not affect commerce. */ }
  }
  window.commerceAttribution = {
    context, event,
    markPoints(code) {
      state.channel = 'points'; state.pointsCode = String(code || '');
      try { sessionStorage.setItem('points-selected-discount', state.pointsCode); } catch (_) { /* Optional. */ }
      save(); tags();
    }
  };
  save(); tags();
  const path = location.pathname.replace(/\/$/, '');
  if (/\/pages\/store$/.test(path)) event('store_view');
  if (/\/products\/[^/]+$/.test(path)) event('product_view');
  if (/\/cart$/.test(path)) event('cart_view');
  let lastCartOpen = 0;
  document.addEventListener('cart:opened', () => {
    const now = Date.now();
    if (now - lastCartOpen < 500) return;
    lastCartOpen = now;
    event('cart_open');
  });
  document.addEventListener('commerce:cart-added', () => event('add_to_cart_success'));
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && /\/checkout\/?$/.test(url.pathname)) event('checkout_click');
  }, true);
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented) return;
    const url = new URL(form.action, location.origin);
    if (url.origin === location.origin && (/\/checkout\/?$/.test(url.pathname) || (/\/cart\/?$/.test(url.pathname) && e.submitter?.name === 'checkout'))) event('checkout_submit');
  });
})();
